var React = require('react');

function ExternalLinkArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 10.6211L10 1.62109","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M9.99955 10.314V1.62109H1.30664","strokeWidth":"2","strokeMiterlimit":"10","key":1})]);
}

ExternalLinkArrow.defaultProps = {"width":"11","height":"12","viewBox":"0 0 11 12","fill":"none"};

module.exports = ExternalLinkArrow;

ExternalLinkArrow.default = ExternalLinkArrow;
